<!--
 * @Author: shfang
 * @Date: 2022-11-30 10:06:59
 * @LastEditors: shfang
 * @LastEditTime: 2022-12-03 16:22:27
 * @Description: file content
 * @FilePath: \identityserver4web\src\views\Auth\wxLogin.vue
-->
<template>
  <div></div>
</template>
<script>
import { getUrlParam } from "@/utils/wxlogin.js";
export default {
  data() {
    return {};
  },
  mounted() {
    var that = this;
    // that.$toast.loading({
    //   message: "登录中...",
    //   duration: 30000,
    // });
    console.log(that.$route.query);

    let code = that.$route.query.code || getUrlParam("code");
    if (code) {
      //获取微信信息接口,提供code给后台这个接口，
      that.$http
        .get("/xxxxx", {
          params: {
            code: code,
          },
        })
        .then((res) => {
          that.$toast.clear();
          let datas = res.data;
          that.$toast.success("微信登录成功");
          setTimeout(function() {
            sessionStorage.setItem("wxUser", JSON.stringify(datas)); //把微信信息存个临时缓存
            window.location.href = "xxx"; //获取成功后需要跳转的页面
            // that.$router.replace('/index')
          }, 200);
        })
        .catch(function(error) {
          console.log("error", error);
        });
    } else {
      that.$toast.fail("获取不到code！");
      that.$router.replace("/");
    }
  },
};
</script>
